<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div class="list-wrapper">
  <div class="header">
    <!-- Header left -->
    <div class="left">
      <!-- Sidebar toggle button -->
      <button class="sidebar-toggle" mat-icon-button (click)="projectsListComponent.drawer.toggle()">
        <mat-icon [svgIcon]="'menu'"></mat-icon>
      </button>

      <!-- Category name -->
      <div class="category">{{ pipeline.name }}</div>

      <button
        class="today lt-md:hidden"
        data-cy="column-select-button"
        data-intercom-target="Deal List View - Fields Eyeball"
        mat-icon-button
        (click)="openFieldDefsPanel()"
        [appAuthorize]="canSelectColumns()"
        #customFieldPanelOrigin
        #fieldDefsPanelOrigin
      >
        <mat-icon [svgIcon]="'visibility'"></mat-icon>
      </button>
      <div class="flex flex-row" *ngIf="selection.selected.length > 0">
        <button
          data-cy="table-deal-update-seleted-button"
          mat-stroked-button
          [matTooltip]="'Mass Update Selected'"
          [matMenuTriggerFor]="massUpdatePanelMenu"
        >
          Update Selected
        </button>

        <mat-menu #massUpdatePanelMenu="matMenu">
          <button
            mat-menu-item
            (click)="openPortfolioActionsDialog('new')"
            [disabled]="!canEditAllSelectedDeals() || !enableMerge"
          >
            <mat-icon [svgIcon]="'ts_folder-plus'"></mat-icon>
            <span>Create Portfolio</span>
          </button>
          <button
            mat-menu-item
            (click)="openPortfolioActionsDialog('existing')"
            [disabled]="!canEditAllSelectedDeals() || !enableMerge"
          >
            <mat-icon [svgIcon]="'ts_folder-download'"></mat-icon>
            <span>Add to Portfolio</span>
          </button>
          <button
            mat-menu-item
            (click)="openPortfolioActionsDialog('split')"
            [disabled]="!canEditAllSelectedDeals() || !enableSplit"
          >
            <mat-icon [svgIcon]="'ts_folder-times'"></mat-icon>
            <span>Separate Portfolio</span>
          </button>
          <mat-divider></mat-divider>
          <button
            mat-menu-item
            (click)="changeStatusOfSelected()"
            [disabled]="!canEditAllSelectedDeals()"
            [matTooltip]="!canEditAllSelectedDeals() ? PERMISSION_DENY_LABEL : null"
          >
            <mat-icon [svgIcon]="'sync'"></mat-icon>
            <span>Update Status</span>
          </button>
          <button
            mat-menu-item
            (click)="moveSelectedDeals()"
            *ngIf="!isPipelineDynamic()"
            [disabled]="!canEditAllSelectedDeals()"
          >
            <mat-icon [svgIcon]="'swap_horiz'"></mat-icon>
            <span>Move Views</span>
          </button>
          <button
            mat-menu-item
            (click)="changeSelectedLayouts()"
            [appAuthorize]="[NewPermission.DEALS_MANAGE_LAYOUT, canEditAllSelectedDeals()]"
            denyAction="disable"
            matTooltip
          >
            <mat-icon [svgIcon]="'dashboard'"></mat-icon>
            <span>Change Layout</span>
          </button>
          <button
            [disabled]="!canDeleteAllSelectedDeals()"
            data-cy="update-selected-delete-button"
            mat-menu-item
            [matTooltip]="!canDeleteAllSelectedDeals() ? PERMISSION_DENY_LABEL : null"
            (click)="deleteSelectedProjects()"
            *ngIf="!isPipelineDynamic()"
          >
            <mat-icon [svgIcon]="'delete'"></mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>
      </div>

      <ng-template #fieldDefsPanel>
        <ng-container *ngIf="hasNestedFiltersOn; else noNestedFields">
          <div class="field-def-panel">
            <div class="fields-panel-header">
              <div class="new-field">
                <mat-icon [svgIcon]="'search'"></mat-icon>
                <input
                  type="text"
                  placeholder="Enter field name"
                  (input)="filterFields($event)"
                  (keydown)="filterFieldsInputKeyDown($event)"
                  [maxLength]="50"
                  #newTagInput
                />
              </div>
            </div>
            <div class="available-fields">
              <ng-container
                *ngFor="let filteredField of filteredFieldDefs | groupBy: '_parentFieldName' : '_parentFieldLabel'"
              >
                <p *ngIf="filteredField?.groupLabel?.length > 1" class="font-bold text-gray-default p-2">
                  {{ filteredField?.groupLabel }}
                </p>
                <ng-container *ngFor="let item of filteredField.items; trackBy: trackByFn">
                  <mat-checkbox
                    *ngIf="filteredField?.groupLabel?.length > 1 || item?.type !== 'record'"
                    [ngClass]="{ 'pl-3': filteredField?.groupLabel?.length > 1 }"
                    [disabled]="displayColumns.length < 2 && displayColumns.includes(item?.name)"
                    [color]="'primary'"
                    [checked]="displayColumns.includes(item?.name)"
                    (change)="toggleDisplayColumn(item?.name, $event)"
                  >
                    {{ item.label }}
                  </mat-checkbox>
                </ng-container>
              </ng-container>
            </div>
            <div
              class="create-tag"
              *ngIf="shouldShowCreateCustomFieldButton(newTagInput.value)"
              (click)="openCustomFieldPanel(newTagInput.value); newTagInput.value = ''"
              matRipple
            >
              <mat-icon [svgIcon]="'add'"></mat-icon>
              <div>
                Create "<strong>{{ newTagInput.value }}</strong
                >"
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noNestedFields>
          <div class="contacts-details-tags-panel visible-fields">
            <div class="tags-panel-header">
              <div class="new-tag">
                <mat-icon [svgIcon]="'search'"></mat-icon>
                <input
                  data-cy="column-select-filter-input"
                  type="text"
                  placeholder="Enter field name"
                  (input)="filterFields($event)"
                  (keydown)="filterFieldsInputKeyDown($event)"
                  [maxLength]="50"
                  #newTagInput
                />
              </div>
              <button class="toggle-edit-mode" mat-icon-button (click)="toggleEditDisplayColumnsModel()">
                <mat-icon
                  *ngIf="!(displayColumnsEditMode || shouldShowCreateCustomFieldButton(newTagInput?.value))"
                  [svgIcon]="'edit'"
                ></mat-icon>

                <mat-icon *ngIf="displayColumnsEditMode" [svgIcon]="'check'"></mat-icon>
              </button>
            </div>

            <div class="available-tags" [ngClass]="{ editing: displayColumnsEditMode }">
              <ng-container *ngIf="!displayColumnsEditMode">
                <mat-checkbox
                  *ngFor="let fieldDef of filteredFieldDefs; trackBy: trackByFn"
                  [color]="'primary'"
                  [checked]="displayColumns.includes(fieldDef.name)"
                  (change)="toggleDisplayColumn(fieldDef.name, $event)"
                  data-cy="column-select-list-item"
                >
                  {{ fieldDef.label }}
                </mat-checkbox>
              </ng-container>
              <ng-container *ngIf="displayColumnsEditMode">
                <div cdkDropList [cdkDropListData]="filteredFieldDefs" (cdkDropListDropped)="droppedFilterDef($event)">
                  <div
                    class="tag-edit flex items-center"
                    *ngFor="let column of displayColumns; trackBy: trackByFn"
                    cdkDrag
                  >
                    <ng-container *ngIf="lookupField(column) as fieldDef">
                      <div class="drag-handle" cdkDragHandle>
                        <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                      </div>
                      <div>
                        {{ fieldDef.label }}
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
            <div
              class="create-tag"
              *ngIf="shouldShowCreateCustomFieldButton(newTagInput.value)"
              (click)="openCustomFieldPanel(newTagInput.value); newTagInput.value = ''"
              matRipple
            >
              <mat-icon [svgIcon]="'add'"></mat-icon>
              <div>
                Create "<strong>{{ newTagInput.value }}</strong
                >"
              </div>
            </div>
          </div>
        </ng-template>
      </ng-template>

      <ng-template #customFieldPanel>
        <app-add-field
          [mentionConfig]="mentionConfig"
          [formValue]="{ label: fieldSearchValue }"
          (fieldAdded)="onFieldAdded($event)"
        ></app-add-field>
      </ng-template>
    </div>
    <div class="flex justify-end items-center">
      <ng-container *ngIf="canAddUserToPipeline">
        <pipeline-user-associations [pipelineId]="pipeline.id"></pipeline-user-associations>
      </ng-container>
      <div class="main-actions">
        <project-list-header [pipeline]="pipeline"></project-list-header>

        <div class="projects-list-filter">
          <list-filter
            (filterSearchInput)="searchInput($event)"
            (projectFilters)="filterProjects($event)"
            [queryFilters]="queryFilters"
            [savedFilter]="savedFilter"
            [allowIncludeChildren]="true"
            [hideSaveButton]="hideSaveButton()"
            [hideFilterName]="isPipelineDynamic()"
            [allowRelatedObjectFields]="hasNestedFiltersOn"
          ></list-filter>
        </div>

        <!-- Add contact button -->
        <input style="display: none" type="file" (change)="onProjectFileChanged($event)" #projectFileInput />

        <ts-button
          [appAuthorize]="Permission.DEALS_ADD"
          denyAction="disable"
          data-cy="deal-add-button"
          data-intercom-target="Deal List View - Add Deal Button"
          id="add-project"
          class="add-contact ml-2"
          [matMenuTriggerFor]="addProjectMenu"
          [variant]="'primary'"
        >
          <ng-container *ngIf="!uploadingFile">
            <mat-icon [svgIcon]="'keyboard_arrow_down'"></mat-icon>
            Add
          </ng-container>
          <mat-progress-spinner *ngIf="uploadingFile" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
        </ts-button>
        <mat-menu #addProjectMenu="matMenu">
          <button data-cy="enter-details-button" id="create-project" mat-menu-item (click)="openCustomDrawer()">
            <span class="ml-2"> <mat-icon svgIcon="add"></mat-icon> Enter Details </span>
          </button>
          <button id="create-project" mat-menu-item (click)="createProject()" [disabled]="isPipelineDynamic()">
            <span class="ml-2"> <mat-icon svgIcon="add"></mat-icon> By Url </span>
          </button>
          <button mat-menu-item (click)="projectFileInput.click()" [disabled]="isPipelineDynamic()">
            <span class="ml-2"> <mat-icon [svgIcon]="'publish'"></mat-icon> Upload OM </span>
          </button>
          <button mat-menu-item (click)="navigateToProjectsAddMap()" [disabled]="isPipelineDynamic()">
            <span class="ml-2"> <mat-icon [svgIcon]="'language'"></mat-icon> Select On Map </span>
          </button>
        </mat-menu>

        <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu">
          <mat-icon [svgIcon]="'more_vert'"></mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu">
          <button
            [appAuthorize]="NewPermission.DEALS_PUBLIC_CUSTOM_VIEWS"
            denyAction="hide"
            mat-menu-item
            (click)="duplicatePipeline()"
          >
            <mat-icon [svgIcon]="'file_copy'"></mat-icon>
            Copy View
          </button>
          <ng-container *ngIf="isUserAdmin">
            <button mat-menu-item (click)="navigateToImportsSettings()">
              <mat-icon [svgIcon]="'publish'"></mat-icon>
              Go to Imports Settings
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </div>
    <div class="loader" *ngIf="isLoading">
      <mat-progress-bar class="table-loading-bar" [mode]="'indeterminate'"></mat-progress-bar>
    </div>
  </div>

  <div class="projects-list" [ngClass]="{ loading: isLoading }">
    <div class="table-wrapper" #tableWrapper>
      @if (newTable) {
        <ts-table-grouped
          [relatedToRedirectConfig]="relatedToRedirectConfig"
          [columnDefs]="columnDefs"
          [rowData]="rowData"
          [data]="data"
          [treeData]="true"
          [getDataPath]="getDataPath"
          [hasCheckboxColumn]="true"
          [gridOptions]="gridOptions"
          [autoGroupColumnDef]="autoGroupColumnDef"
          [loading]="isLoading$ | async"
          [autoHeight]="false"
          [optionsFilterFn]="optionsFilterFn"
          (cellEditingStopped)="onProjectCellEditingStopped($event)"
          (sortChanged)="onSortChanged($event)"
          (selectionChanged)="onSelectionChanged($event)"
          (onColumnMove)="onColumnMoved($event)"
          (gridReady)="onGridReady($event)"
          (columnResized)="onColumnResized($event)"
          (gridColumnsChanged)="onDataUpdate()"
        >
        </ts-table-grouped>
      } @else {
        <table
          mat-table
          matSort
          [matSortActive]="'project_stage_rank'"
          [matSortDisableClear]="true"
          [matSortDirection]="'desc'"
          [multiTemplateDataRows]="true"
          [dataSource]="chunkedProjectsArray"
          class="table-container"
          cdkDropList
          cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="dropColumns($event)"
        >
          <ng-container matColumnDef="icon" sticky>
            <th mat-header-cell *matHeaderCellDef class="checkbox-header">
              <mat-checkbox
                [color]="'primary'"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let project" class="checkbox-cell">
              <mat-checkbox
                data-cy="table-deal-single-checkbox"
                [color]="'primary'"
                (click)="$event.stopPropagation()"
                (change)="$event ? toggleProject(project) : null"
                [checked]="isProjectSelected(project)"
              >
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="title" sticky>
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="title-header">{{ titleField.label }}</th>
            <td mat-cell *matCellDef="let project; let i = dataIndex">
              <div class="title-content">
                <span class="left">
                  <button class="more-menu" *ngIf="isParent(project) && !this.queryFilters?.includeChildren">
                    <mat-icon
                      *ngIf="!expanded(project) && isParent(project)"
                      [svgIcon]="'chevron_right'"
                      (click)="expand(project, i)"
                    ></mat-icon>
                    <mat-icon
                      *ngIf="expanded(project) && isParent(project) && !isLoadingChildren[i]"
                      [svgIcon]="'expand_more'"
                      (click)="expand(project, i)"
                    ></mat-icon>
                    <mat-icon *ngIf="!isParent(project)" [svgIcon]="'none'"></mat-icon>
                    <mat-progress-spinner
                      *ngIf="isLoadingChildren[i]"
                      [diameter]="24"
                      [mode]="'indeterminate'"
                    ></mat-progress-spinner>
                  </button>
                </span>
                <span class="thumbnail" *ngIf="account?.show_images_on_pipeline">
                  <a [routerLink]="['../' + project.id]"
                    ><img
                      *ngIf="project.featured_image_url"
                      loading="lazy"
                      width="30"
                      height="20"
                      style="
                        background-image: url('assets/images/placeholder.jpeg');
                        width: 30px;
                        background-size: 30px 20px;
                      "
                      onerror="this.onerror=null;this.src='assets/images/placeholder.jpeg';"
                      [src]="project.featured_image_url"
                  /></a>
                  <span *ngIf="!project.featured_image_url"> No Image </span>
                </span>
                <span
                  class="title font-medium"
                  [ngClass]="{
                    'pl-5': !isParent(project) && isChild(i, project) && (!account || !account.show_images_on_pipeline),
                  }"
                  ><a data-cy="table-deal-name-label" [routerLink]="['../' + project.id, 'details', 'overview']">{{
                    project.title
                  }}</a></span
                >
              </div>
            </td>
          </ng-container>
          <ng-container [matColumnDef]="column" *ngFor="let column of loopDisplayColumns; index as i">
            <ng-container *ngIf="lookupField(column) as fieldDef">
              <th
                mat-header-cell
                mat-sort-header
                [disabled]="isLinkedFieldColumn(fieldDef) || !fieldDef.meta || !fieldDef.meta.sorting"
                *matHeaderCellDef
                cdkDrag
                cdkDragBoundary=".table-container"
                cdkDropList
                cdkDragLockAxis="x"
                [ngClass]="'project-table-head cw-' + i"
                [resizeColumn]="true"
                [index]="i"
              >
                <div class="drag-handle" cdkDragHandle>
                  <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                </div>
                <div>
                  {{ isLinkedFieldColumn(fieldDef) ? getHeaderLabel(fieldDef) : fieldDef.label }}
                </div>
              </th>
              <td
                mat-cell
                *matCellDef="let project"
                contenteditable="!fieldDef.meta.readonly && project?.permissions?.is_editable"
                (click)="editField(project, fieldDef)"
                [class.locked]="fieldDef.locked || !project?.permissions?.is_editable"
              >
                <div
                  class="editable"
                  [attr.data-cy]="'app-table-editable-' + fieldDef.type"
                  tabindex="0"
                  (focus)="editField(project, fieldDef)"
                  [matTooltip]="getTooltip(project, fieldDef)"
                  *ngIf="
                    pipeableTypes.includes(fieldDef.type) && !editableDictionary[project.id + '-' + fieldDef.name];
                    else editableField
                  "
                >
                  <ng-container *ngIf="isLinkedFieldColumn(fieldDef); else defaultField">
                    <linkable-related-field-cell
                      [type]="fieldDef?.related_to_type"
                      [value]="getLinkedFieldValue(project, fieldDef.name)"
                    ></linkable-related-field-cell>
                  </ng-container>
                  <ng-template #defaultField>
                    {{ project[fieldDef.name] | readableField: project : fieldDef : options }}
                  </ng-template>
                </div>
                <ng-template #editableField>
                  <app-editable
                    [fieldDef]="fieldDef"
                    [model]="project"
                    [data]="data"
                    (onUpdate)="onUpdate($event, project)"
                    [editMode]="!fieldDef.meta?.readonly"
                    (onEndEditing)="onEndEditing(project, fieldDef)"
                  >
                  </app-editable>
                </ng-template>
              </td>
            </ng-container>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="tableDisplayColumns; sticky: true"></tr>
          <tr
            class="product-row"
            mat-row
            *matRowDef="let project; columns: tableDisplayColumns; when: isProject"
            data-cy="table-deal-project-row"
          ></tr>

          <ng-container matColumnDef="group_header" sticky>
            <td mat-cell *matCellDef="let group" class="groupCell label" colspan="2">
              {{ group.label }} ({{ group.totalCount }})
            </td>
          </ng-container>
          <ng-container
            [matColumnDef]="groupSummaryColumn"
            *ngFor="let groupSummaryColumn of getGroupedSummaryColumns()"
          >
            <td mat-cell *matCellDef="let group" class="groupCell">
              <ng-container *ngIf="lookupGroupSummaryField(groupSummaryColumn) as fieldDef">
                <div
                  class="flex flex-auto justify-between"
                  *ngIf="
                    fieldDef.type == 'money' ||
                    fieldDef.type == 'percent' ||
                    fieldDef.type == 'number' ||
                    fieldDef.type == 'decimal'
                  "
                >
                  <div class="mt-auto mb-auto">
                    <ng-container *ngIf="fieldDef.displayGroupedType && fieldDef.displayGroupedType == 'total'">
                      <ng-container *ngIf="fieldDef.type == 'money'">
                        <small
                          *ngIf="
                            group.summaryColumns[groupSummaryColumn] &&
                            group.summaryColumns[groupSummaryColumn].total &&
                            group.summaryColumns[groupSummaryColumn].total > 0
                          "
                          >Sum:
                          {{
                            group.summaryColumns[groupSummaryColumn].total | tsCurrency: 'USD' : 'symbol' : '1.0'
                          }}</small
                        >
                      </ng-container>
                      <ng-container
                        *ngIf="fieldDef.displayGroupedType && (fieldDef.type == 'decimal' || fieldDef.type == 'number')"
                      >
                        <small
                          *ngIf="
                            group.summaryColumns[groupSummaryColumn] &&
                            group.summaryColumns[groupSummaryColumn].total &&
                            group.summaryColumns[groupSummaryColumn].total > 0
                          "
                          >Sum: {{ group.summaryColumns[groupSummaryColumn].total | formatNumber: 0 }}</small
                        >
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="fieldDef.displayGroupedType && fieldDef.displayGroupedType == 'average'">
                      <small
                        *ngIf="
                          group.summaryColumns[groupSummaryColumn] &&
                          group.summaryColumns[groupSummaryColumn].average &&
                          group.summaryColumns[groupSummaryColumn].average > 0
                        "
                      >
                        <ng-container *ngIf="fieldDef.type == 'money'">
                          Avg:
                          {{ group.summaryColumns[groupSummaryColumn].average | tsCurrency: 'USD' : 'symbol' : '1.0' }}
                        </ng-container>
                        <ng-container *ngIf="fieldDef.type == 'percent'">
                          Avg: {{ group.summaryColumns[groupSummaryColumn].average | formatNumber: 2 }}%
                        </ng-container>
                        <ng-container *ngIf="fieldDef.type == 'decimal' || fieldDef.type == 'number'">
                          Avg: {{ group.summaryColumns[groupSummaryColumn].average | formatNumber: 0 }}
                        </ng-container>
                      </small>
                    </ng-container>
                    <ng-container
                      *ngIf="fieldDef.displayGroupedType && fieldDef.displayGroupedType == 'weighted_average'"
                    >
                      <small
                        *ngIf="
                          group.summaryColumns[groupSummaryColumn] &&
                          group.summaryColumns[groupSummaryColumn].weighted_average &&
                          group.summaryColumns[groupSummaryColumn].weighted_average > 0
                        "
                      >
                        <ng-container *ngIf="fieldDef.type == 'percent'">
                          WAvg: {{ group.summaryColumns[groupSummaryColumn].weighted_average | formatNumber: 2 }}%
                        </ng-container>
                      </small>
                    </ng-container>
                  </div>
                  <div>
                    <button [matMenuTriggerFor]="actionsMenu" mat-icon-button class="z-0">
                      <mat-icon [svgIcon]="'expand_more'" class="icon-size-12"></mat-icon>
                    </button>
                    <mat-menu #actionsMenu="matMenu">
                      <button mat-menu-item (click)="toggleGroupedTotalAverages(null, fieldDef)">
                        <span class="ml-2"></span>
                      </button>
                      <button
                        *ngIf="fieldDef.type !== 'percent'"
                        mat-menu-item
                        (click)="toggleGroupedTotalAverages('total', fieldDef)"
                      >
                        <span class="ml-2">Sum</span>
                      </button>
                      <button mat-menu-item (click)="toggleGroupedTotalAverages('average', fieldDef)">
                        <span class="ml-2">Average</span>
                      </button>
                      <button
                        mat-menu-item
                        (click)="toggleGroupedTotalAverages('weighted_average', fieldDef)"
                        *ngIf="fieldDef.type == 'percent'"
                      >
                        <span class="ml-2">Weighted Average</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <tr
            class="product-row"
            mat-row
            *matRowDef="let project; columns: groupedSummaryColumns; when: isGroup"
            data-cy="table-deal-summary-row"
          ></tr>
          <ng-container matColumnDef="icon2" sticky>
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" class="checkbox-header">
              <mat-checkbox
                [color]="'primary'"
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let project" class="checkbox-cell">
              <div class="title-content flex-row checkbox-content">
                <span class="left">
                  <mat-checkbox
                    [color]="'primary'"
                    (click)="$event.stopPropagation()"
                    (change)="$event ? toggleProject(project) : null"
                    [checked]="isProjectSelected(project)"
                  >
                  </mat-checkbox>
                </span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="title2" sticky>
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="title-header">Name</th>
            <td mat-cell *matCellDef="let project">
              <div class="title-content">
                <span style="width: 30px; height: 41px" [class.display-none]="includeChildrenToggled"></span>

                <!-- START -->
                <span class="thumbnail" *ngIf="account?.show_images_on_pipeline">
                  <a [routerLink]="['../' + project.id]"
                    ><img
                      *ngIf="project.featured_image_url"
                      loading="lazy"
                      width="30"
                      height="20"
                      style="
                        background-image: url('assets/images/placeholder.jpeg');
                        width: 30px;
                        background-size: 30px 20px;
                      "
                      onerror="this.onerror=null;this.src='assets/images/placeholder.jpeg';"
                      [src]="project.featured_image_url"
                  /></a>
                  <span *ngIf="!project.featured_image_url"> No Image </span>
                </span>
                <span class="title font-medium"
                  ><a [routerLink]="['../' + project.id, 'details', 'overview']">{{ project.title }}</a></span
                >
                <!-- END -->
              </div>
            </td>
          </ng-container>
          <ng-container [matColumnDef]="duplicateColName(column)" *ngFor="let column of loopDisplayColumns; index as i">
            <ng-container *ngIf="lookupField(column) as fieldDef">
              <th
                mat-header-cell
                mat-sort-header
                [disabled]="!fieldDef.meta || !fieldDef.meta.sorting"
                *matHeaderCellDef
                cdkDrag
                cdkDragBoundary=".table-container"
                cdkDropList
                cdkDragLockAxis="x"
                [ngClass]="'project-table-head cw-' + i"
                [resizeColumn]="true"
                [index]="i"
              >
                <div class="drag-handle" cdkDragHandle>
                  <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                </div>
                <div>{{ fieldDef.label }}</div>
              </th>
              <td mat-cell *matCellDef="let project" contenteditable="!fieldDef.meta.readonly">
                <div
                  class="editable"
                  tabindex="0"
                  (focus)="editField(project, fieldDef)"
                  [matTooltip]="getTooltip(project, fieldDef)"
                  *ngIf="
                    pipeableTypes.includes(fieldDef.type) && !editableDictionary[project.id + '-' + fieldDef.name];
                    else editableField
                  "
                >
                  {{ project[fieldDef.name] | readableField: project : fieldDef : options }}
                </div>
                <ng-template #editableField>
                  <app-editable
                    [fieldDef]="fieldDef"
                    [model]="project"
                    [data]="data"
                    (onUpdate)="onUpdate($event, project)"
                    [editMode]="!fieldDef.meta?.readonly"
                    (onEndEditing)="onEndEditing(project, fieldDef)"
                  >
                  </app-editable>
                </ng-template>
              </td>
            </ng-container>
          </ng-container>
          <tr
            [hidden]="checkHiddenChildren(project)"
            class="product-row"
            mat-row
            *matRowDef="let project; columns: parentColumns(); when: isChild"
            data-cy="table-deal-child-row"
          ></tr>
        </table>
      }
    </div>
    <div class="toolbar">
      <div class="toolbar-row">
        <div class="bottom-toolbar-left">
          <div class="mt10">
            <mat-form-field class="flex-auto gt-xs:pr-3 group-by-select">
              <mat-label>&nbsp;</mat-label>
              <mat-select
                [ngModel]="pipeline.table_definition.groupBy || defaultGroupBy"
                (ngModelChange)="pipeline.table_definition.groupBy || (defaultGroupBy = $event)"
                (selectionChange)="onChangeGroupBy($event)"
              >
                <mat-option
                  *ngFor="
                    let fieldDef of filteredFieldDefs | filterBy: [] : '' : filterGroupByOptions;
                    trackBy: trackByFn
                  "
                  [value]="fieldDef.name"
                  >{{ fieldDef.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="groupByMemento && pipeline.table_definition.groupBy !== groupByMemento">
              <button
                mat-flat-button
                disableRipple
                color="secondary"
                (click)="saveGroupBy(true)"
                matTooltip="Reset your group by back to the view's default."
              >
                Reset
              </button>
              <button
                mat-flat-button
                disableRipple
                color="primary"
                (click)="saveGroupBy()"
                [appAuthorize]="Permission.CONTROL_GROUP_BY_DROPDOWN"
                matTooltip="Save this as view default."
              >
                Save
              </button>
            </ng-container>
          </div>
          <button
            mat-icon-button
            [appAuthorize]="NewPermission.DEALS_SHARING_RECORDS"
            [disabled]="!chunkedProjectsArray?.length || exportingCsv"
            (click)="exportProjects('csv', true)"
            class="mr-0"
          >
            <mat-icon
              [matTooltip]="chunkedProjectsArray?.length ? 'Export as Csv' : 'No data to export'"
              title="Export as CSV"
              *ngIf="!exportingCsv"
              >save_alt
            </mat-icon>
            <mat-progress-spinner *ngIf="exportingCsv" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
          </button>
          <button
            mat-icon-button
            [appAuthorize]="NewPermission.DEALS_SHARING_RECORDS"
            [disabled]="!chunkedProjectsArray?.length || exportingPdf"
            (click)="exportProjects('pdf', true)"
            class="mr-0"
          >
            <mat-icon
              [matTooltip]="chunkedProjectsArray?.length ? 'Export as Pdf' : 'No data to export'"
              title="Export as PDF"
              *ngIf="!exportingPdf"
              >picture_as_pdf
            </mat-icon>
            <mat-progress-spinner *ngIf="exportingPdf" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
          </button>
          <button mat-icon-button [routerLink]="['/reports']">
            <mat-icon>pie_chart</mat-icon>
          </button>
        </div>
        <span class="example-spacer"></span>
        <mat-paginator
          [ngClass]="{ loading: isLoading }"
          [length]="pagination.length"
          [pageIndex]="pagination.page"
          [pageSize]="pagination.size"
          [pageSizeOptions]="pageSizeOptions()"
          [showFirstLastButtons]="true"
          (page)="onPageChange($event)"
        >
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
